const bandFinderNavSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
 width="53.686px" height="33.582px" viewBox="0 0 53.686 33.582" enable-background="new 0 0 53.686 33.582" xml:space="preserve">
<g>
<path fill="#EF1D9B" d="M42.876,2.989c0-0.189-0.094-0.332-0.285-0.426l-1.565-0.711l-0.711-1.566C40.269,0.097,40.078,0,39.889,0
c-0.189,0-0.333,0.097-0.427,0.286L38.75,1.853l-1.611,0.711c-0.19,0.046-0.284,0.236-0.284,0.426s0.094,0.331,0.284,0.426
l1.563,0.713l0.714,1.565c0.048,0.189,0.236,0.285,0.427,0.285c0.189,0,0.332-0.096,0.428-0.285l0.71-1.565l1.565-0.713
C42.736,3.37,42.83,3.179,42.876,2.989"/>
<path fill="#EF1D9B" d="M53.686,6.002c0-0.187-0.097-0.33-0.285-0.426l-1.567-0.711l-0.711-1.568
c-0.047-0.188-0.237-0.282-0.426-0.282c-0.19,0-0.332,0.143-0.427,0.282l-0.712,1.521l-1.566,0.711
c-0.19,0.047-0.283,0.236-0.283,0.428c0,0.188,0.093,0.33,0.283,0.427l1.566,0.711L50.27,8.66c0.045,0.188,0.236,0.283,0.427,0.283
c0.188,0,0.379-0.143,0.379-0.236l0.709-1.566l1.568-0.711C53.544,6.334,53.637,6.146,53.686,6.002"/>
<path fill="#EF1D9B" d="M45.865,12.118c0-0.191-0.095-0.335-0.285-0.428l-1.564-0.712l-0.711-1.563
c-0.048-0.191-0.237-0.285-0.429-0.285c-0.143,0-0.331,0.094-0.424,0.235l-0.714,1.567l-1.565,0.711
c-0.189,0.047-0.285,0.237-0.285,0.428c0,0.188,0.096,0.332,0.285,0.425l1.565,0.713l0.714,1.565
c0.045,0.189,0.235,0.283,0.424,0.283c0.191,0,0.332-0.094,0.429-0.283l0.711-1.565l1.564-0.713
C45.722,12.45,45.865,12.308,45.865,12.118"/>
<g>
<path fill="#EF1D9B" d="M0.017,19.512l0.686,3.399c0.078,0.397,0.425,0.668,0.811,0.668c0.055,0,0.109-0.005,0.166-0.016
l2.387-0.482l0.123,0.62c0.08,0.389,0.423,0.667,0.813,0.667c0.029,0,0.061-0.005,0.091-0.008l23.322-2.558l0.251,1.243
c0.044,0.217,0.171,0.407,0.354,0.528c0.137,0.09,0.298,0.137,0.459,0.137c0.054,0,0.109-0.005,0.164-0.014l2.931-0.594
c0.449-0.089,0.74-0.525,0.649-0.974l-0.317-1.578c1.206-0.423,2.237-1.221,2.957-2.304c0.874-1.316,1.184-2.893,0.872-4.441
c-0.588-2.921-3.249-4.906-6.142-4.737l-0.289-1.424c-0.09-0.452-0.526-0.738-0.976-0.651l-2.931,0.59
c-0.215,0.044-0.405,0.171-0.527,0.355c-0.122,0.182-0.165,0.406-0.122,0.623l0.249,1.244l-15.897,4.715
c-0.44,0.131-0.689,0.594-0.561,1.031c0.13,0.439,0.593,0.688,1.031,0.559l4.146-1.23l1.333,6.611L5.667,22.631l-0.139-0.686
v-0.003L4.842,18.54l0-0.004l-0.138-0.686l2.066-0.611c0.438-0.13,0.689-0.593,0.56-1.031c-0.131-0.438-0.593-0.69-1.031-0.559
l-2.792,0.827c-0.414,0.123-0.663,0.539-0.578,0.959l0.125,0.62l-2.387,0.479c-0.216,0.042-0.406,0.17-0.527,0.354
C0.017,19.072-0.026,19.297,0.017,19.512 M32.575,18.904l-1.651-8.188c0.838-0.002,1.657,0.239,2.371,0.714
c0.947,0.629,1.591,1.588,1.815,2.705c0.225,1.115,0.002,2.249-0.627,3.196C34.008,18.045,33.349,18.586,32.575,18.904
 M27.776,10.223L27.776,10.223L27.54,9.047l1.306-0.262l0.274,1.367v0.001l2.01,9.97v0.001l0.306,1.52l-1.306,0.265l-0.236-1.174
v-0.001L27.776,10.223z M16.315,14.408l10.014-2.971l1.76,8.733L17.705,21.31L16.315,14.408z M1.806,19.995l1.573-0.315
l0.36,1.777l-1.574,0.316L1.806,19.995z"/>
<path fill="#EF1D9B" d="M19.956,33.582c-0.309,0-0.594-0.203-0.685-0.518l-3.41-11.728c-0.111-0.378,0.107-0.776,0.485-0.886
c0.378-0.112,0.775,0.106,0.886,0.486l3.409,11.729c0.111,0.382-0.107,0.775-0.486,0.886
C20.09,33.571,20.023,33.582,19.956,33.582"/>
<path fill="#EF1D9B" d="M13.138,33.582c-0.066,0-0.133-0.011-0.199-0.029c-0.379-0.111-0.597-0.505-0.487-0.887l3.408-11.729
c0.11-0.38,0.509-0.596,0.887-0.488c0.377,0.111,0.596,0.51,0.486,0.886l-3.41,11.729C13.733,33.379,13.448,33.582,13.138,33.582"
/>
</g>
</g>
</svg>

`

export default bandFinderNavSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/bandFinderNavSVG.js